<template>
  <div class="modal-card has-background-white" style="width: auto; border-radius: 0.3rem;">
    <div class="box px-5">
      <h1 class="is-size-5 has-text-black has-text-weight-semibold py-5">
        {{ $t('general.share') }}
      </h1>
      <div class="columns is-mobile is-multiline is-variable is-0-mobile">
        <div class="column has-text-centered">
          <a class="button is-radiusless is-light py-5 px-5"
          :href='"https://twitter.com/intent/tweet?text=" + currentTitle + " " + currentUrl'
          rel="noreferrer noopener" target="_blank">
            <span class="icon is-small has-text-black">
              <i class="fab fa-twitter"></i>
            </span>
          </a>
          <p class="is-size-7 py-2">Twitter</p>
        </div>
        <div class="column has-text-centered">
          <a class="button is-radiusless is-light py-5 px-5"
          :href='"https://www.facebook.com/share.php?u=" + currentUrl'
          rel="noreferrer noopener" target="_blank">
            <span class="icon is-small has-text-black">
              <i class="fab fa-facebook-f"></i>
            </span>
          </a>
          <p class="is-size-7 py-2">Facebook</p>
        </div>
        <div class="column has-text-centered">
          <a class="button is-radiusless is-light py-5 px-5"
          :href='"https://social-plugins.line.me/lineit/share?url=" + currentUrl'
          rel="noreferrer noopener" target="_blank">
            <span class="icon is-small has-text-black">
              <i class="fab fa-line"></i>
            </span>
          </a>
          <p class="is-size-7 py-2">LINE</p>
        </div>
        <div class="column has-text-centered">
          <a class="button is-radiusless is-light py-5 px-5"
          :href='"https://t.me/share/url?url=" + currentUrl + "&text=" + currentTitle'
          rel="noreferrer noopener" target="_blank">
            <span class="icon is-small has-text-black">
              <i class="fab fa-telegram-plane"></i>
            </span>
          </a>
          <p class="is-size-7 py-2">Telegram</p>
        </div>
      </div>

      <div class="divider div-transparent my-5"></div>

      <p class="is-size-7 has-text-weight-medium pt-2">{{ $t('general.copylink') }}</p>
      <b-field>
        <input class="input is-white has-text-grey-light my-2"
              :ref="'inputurl'"
              :value="currentUrl"
              type="text"
              placeholder="Text input"
              style="margin-left: -8px; font-size:10px;" readonly>
        <p class="control">
          <b-button @click="copyurl" type="is-white" icon-pack="far" icon-right="clone" />
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareModal',

  props: {
    shareId: {
      type: String,
    },
    shareRoute: {
      type: String,
    },
    shareTitle: {
      type: String,
    },
  },

  created() {
    this.currentUrl = `https://${window.location.host}/${this.shareRoute}/${this.shareId}`;
    this.currentTitle = this.shareTitle;
  },

  mounted() {
    this.$gtag.event('click_share', {
      event_category: 'general_click',
      event_label: 'User clicked share button',
      value: 1,
    });
  },

  methods: {
    copyurl() {
      this.$refs.inputurl.select();
      document.execCommand('copy');
      this.$buefy.snackbar.open({
        duration: 5000,
        message: this.$t('msgs.copylink'),
        type: 'is-dark',
        position: 'is-bottom',
        actionText: null,
      });
    },
  },
};
</script>
